import { Message } from 'primeng/api';

export class ErrorHandling {
  public static getErrorMessages(error: any, summary: string = null): Message[] {
    let message = 'Unknown error';
    try {
      const exception = JSON.parse(error.response);
      message = exception.message;
    } catch (parsingError) {
      console.error('Error attempting to deserialize error.response from: ', error);
      // TODO: Track the error getting the error message
    }
    return [{
      severity: 'error',
      summary: summary ? summary : message,
      detail: summary ? message : null
    }];
  }
}



// WEBPACK FOOTER //
// ./src/app/ErrorHandling.ts